import { confidenceScaledSizingPolicy, profitScaledSizingPolicy, standardSizingPolicy, } from '../v2/sizingPolicies.js';
/**
 * The parallel, shadowed sizing set `compareShadowSizingPolicyDollarPnl`
 * scores by default: the unmodified quarter-Kelly policy already live
 * everywhere dollar P&L is computed, plus the two opt-in variants from
 * `v2/sizingPolicies.ts` that otherwise sit unused by the app —
 * `confidenceScaledSizingPolicy` and `profitScaledSizingPolicy`. Shadowing
 * them here is retrospective-only, exactly like `DEFAULT_SHADOW_EXIT_POLICIES`:
 * none of these become live by being included in this list.
 */
export const DEFAULT_SHADOW_SIZING_POLICIES = [
    { id: 'quarter-kelly', policy: standardSizingPolicy },
    { id: 'confidence-scaled', policy: confidenceScaledSizingPolicy() },
    { id: 'profit-scaled', policy: profitScaledSizingPolicy() },
];
//# sourceMappingURL=shadowSizingPolicies.js.map